var posting = {};

posting.init = function() {

  posting.checkRewriteUrls();

  posting.idsRelation = {};
  api.noReportCaptcha = !document.getElementById('divReportCaptcha');
  posting.highLightedIds = [];

  posting.postCellTemplate = ''
  + '<div class="innerPost">'
  + '  <!-- TWO-ROW STATUS LINE: same as post.njk (row1 = identity+state, row2 = actions). -->'
  + '  <div class="postInfo title">'
  + '    <div class="statusLineTop">'
  + '      <span class="labelBoard"></span>'
  + '      <input type="checkbox" class="deletionCheckBox">'
  + '      <span class="extraMenuButton">'
  + '        <img class="iconReport" src="/.static/images/icon-report.png" title="Post Menu" alt="">'
  + '      </span>'
  // hide: \e017 glyph on the span's ::before (an <img> can't render ::before);
  // old button-close.gif kept in the DOM (CSS-hidden) for hiding.js lookups.
  + '      <span class="hideButton" title="{{ lang.hidePost }}">'
  + '        <img src="/.static/images/button-close.gif" alt="">'
  + '      </span>'
  // Subject+Name share one shrinkable slot on mobile (ellipsized 2:1);
  // display:contents on desktop so they flow inline as before.
  + '      <span class="nsIdentity">'
  + '        <span class="labelSubject"></span>'
  + '        <a class="linkName"></a>'
  + '      </span>'
  + '      <img class="imgFlag">'
  + '      <span class="modLinks">'
  + '        <a class="linkHistory brackets">H</a>'
  + '        <a class="linkFileHistory brackets">FH</a>'
  + '        <a class="linkOffenseRecord brackets">OR</a>'
  + '      </span>'
  + '      <span class="labelRole"></span>'
  + '      <div class="postMeta">'
  + '        <span class="postMetaSummary" role="button" tabindex="0"><span class="postMetaChev">▸</span></span>'
  + '        <div class="postMetaBody">'
  + '          <span class="spanId">'
  + '            <span class="labelId"></span>'
  + '          </span>'
  + '          <span class="labelCreated"></span>'
  + '        </div>'
  + '      </div>'
  + '    </div>'
  + '    <div class="statusLineBottom">'
  + '      <img class="trashIndicator" title="{{ lang.trashUpper }}" src="/.static/images/trash.png" alt="">'
  + '      <span class="sage"></span>'
  + '      <a class="linkSelf">{{ lang.no }}</a>'
  + '      <a class="linkQuote"></a>'
  + '      <a class="linkEdit brackets">{{ lang.edit }}</a>'
  + '      <div class="postMeta postReplies">'
  + '        <span class="postMetaSummary" role="button" tabindex="0"><span class="replyCount"></span><span class="postMetaChev">▸</span></span>'
  + '        <div class="postMetaBody">'
  + '          <span class="panelBacklinks"></span>'
  + '        </div>'
  + '      </div>'
  + '    </div>'
  + '  </div>'
  + '  <table class="modInfo">'
  + '    <tbody>'
  + '      <tr class="panelBypassId">'
  + '        <th>Bypass</th>'
  + '        <td class="labelBypassId"></td>'
  + '      </tr>'
  + '      <tr class="panelIp">'
  + '        <th>IP</th>'
  + '        <td>'
  + '          <span class="labelIp"></span><span class="panelRange">'
  + '            <span title="Broad range(1/2 octets)">BR</span>: <span class="labelBroadRange"> </span>'
  + '            <span title="Narrow range(3/4 octets)">NR</span>: <span class="labelNarrowRange"> </span>'
  + '          </span>'
  + '        </td>'
  + '      </tr>'
  + '      <tr class="panelRealIp">'
  + '        <th>Real IP</th>'
  + '        <td class="labelRealIp"></td>'
  + '      </tr>'
  + '      <tr class="panelASN">'
  + '        <th>ASN</th>'
  + '        <td class="labelASN"></td>'
  + '      </tr>'
  + '    </tbody>'
  + '  </table>'
  + '  <input class="expandCheckBox hidden" type="checkbox" autocomplete="on">'
  + '  <div class="bottomGradient hidden"></div>'
  + '  <label class="expandLabel brackets hidden">'
  + '    <a class="commentExpand">{{ lang.commentExpand }}</a>'
  + '  </label>'
  + '  <label class="collapseLabel brackets hidden">'
  + '    <a class="commentCollapse">{{ lang.commentCollapse }}</a>'
  + '  </label>'
  + '  <div class="contentOverflow">'
  + '    <div class="panelUploads"></div>'
  + '    <div class="divMessage"></div>'
  + '  </div>'
  + '    <div class="divBanMessage"></div>'
  + '    <div class="labelLastEdit"></div>'
  + '</div>';
  posting.postCellTemplate = posting.postCellTemplate.replace("{{ lang.no }}", lang.no);
  posting.postCellTemplate = posting.postCellTemplate.replace("{{ lang.edit }}", lang.edit);
  posting.postCellTemplate = posting.postCellTemplate.replace("{{ lang.commentExpand }}", lang.commentExpand);
  posting.postCellTemplate = posting.postCellTemplate.replace("{{ lang.commentCollapse }}", lang.commentCollapse);
  // trashUpper (deleted-by-janitor status glyph) + hidePost were missing from this
  // pass -> rendered as literal "{{ lang.trashUpper }}" tooltips on client-built cells
  // (fresh posts / backlink previews). Server cells (post.njk/op.njk) are unaffected.
  posting.postCellTemplate = posting.postCellTemplate.replace("{{ lang.trashUpper }}", lang.trashUpper);
  posting.postCellTemplate = posting.postCellTemplate.replace("{{ lang.hidePost }}", lang.hidePost);

  posting.uploadCell = ''
    + '<div class="uploadDetails">'
    + '  <div class="nameFlex">'
    + '    <div class="originalFileName"><a class="originalNameLink"></a></div><div class="originalFileExt"><a class="originalNameLink2"></a></div>'
    + '  </div><br>'
    + '  <a class="nameLink" target="_blank">{{ lang.openFile }}</a>'
    + '  <span class="sizeLabel"></span>,'
    + '  <span class="dimensionLabel"></span>'
    + '  <a class="editInOekaki" style="display:none">Edit</a>'
    + '  <a class="unlinkLink brackets">U</a>'
    + '  <a class="unlinkAndDeleteLink brackets">D</a>'
    + '  <div style="display:none" class="divHash">'
    + '  <span>SHA256: <span class="labelHash"></span></span>'
    + '  </div>'
    + '</div>'
    + '<a class="imgLink" target="_blank"></a>';

  posting.sizeOrders = [ 'B', 'KB', 'MB', 'GB', 'TB' ];

  posting.reverseHTMLReplaceTable = {};

  for ( var key in api.htmlReplaceTable) {
    posting.reverseHTMLReplaceTable[api.htmlReplaceTable[key]] = key;
  }

  if (document.getElementById('deleteFormButton')) {
    api.convertButton('trashFormButton', posting.trashPosts);
    api.convertButton('reportFormButton', posting.reportPosts, 'reportField');
    api.convertButton('deleteFormButton', posting.deletePosts, 'deletionField');
  }

  if (settings.get('convertLocalTimes')) {
    posting.updateAllLocalTimes();
  }

  if (settings.get('relativeTime')) {
    posting.updateAllRelativeTimes();
    setInterval(posting.updateAllRelativeTimes, 1000 * 60 * 1);
  }

  posting.applyAnimationSetting(settings.get('autoPlayAnimations'));

  if (settings.get('editInOekaki')) {
    posting.updateAllEditLinks();
  }

  if (window.location.pathname == "/mod.js" || /^\/\w+\/last\//.test(window.location.pathname)) {
    posting.updateAllModLinks();
  }

  if (window.location.pathname == "/mod.js" || window.location.pathname == "/latestPostings.js" || window.location.pathname == "/openReports.js") {
    posting.updateAllAsnLinks();
  }

  if (typeof (thread) !== 'undefined') {
    return;
  }

  var ids = document.getElementsByClassName('labelId');

  for (i = 0; i < ids.length; i++) {
    posting.processIdLabel(ids[i]);
  }

};

posting.setLocalTime = function(time) {

  time.innerHTML = api.formatDateToDisplay(new Date(time.innerHTML + ' UTC'),
      true);

};

posting.applyBans = function(captcha) {

  var typedReason = document.getElementById('fieldBanReason').value.trim();
  var typedDuration = document.getElementById('fieldDuration').value.trim();
  var typedMessage = document.getElementById('fieldbanMessage').value.trim();
  var banType = document.getElementById('comboBoxBanTypes').selectedIndex;

  var params = {
    action : 'ban',
    reasonBan : typedReason,
    captchaBan : captcha,
    banType : banType,
    duration : typedDuration,
    banMessage : typedMessage,
    nonBypassable : document.getElementById('checkBoxNonBypassable').checked,
    globalBan : document.getElementById('checkboxGlobalBan').checked
  };

  posting.newGetSelectedContent(params);

  api.formApiRequest('contentActions', params, function requestComplete(status,
      data) {

    if (status === 'ok') {
      alert('Bans applied');
    } else {
      alert(status + ': ' + JSON.stringify(data));
    }

  });
};

posting.validateDurationFormat = function(duration) {
  var regex = /^(\d+[yMdhms]\s*)+$/;
  return regex.test(duration);
};

posting.banPosts = function() {

  var typedDuration = document.getElementById('fieldDuration').value.trim();

  if (typedDuration && !posting.validateDurationFormat(typedDuration)) {
    alert("Ban duration does not match expected format.");
    return;
  }

  if (!document.getElementsByClassName('divBanCaptcha').length) {
    return posting.applyBans();
  }

  var typedCaptcha = document.getElementById('fieldCaptchaBan').value.trim();

  if (typedCaptcha && /\W/.test(typedCaptcha)) {
    alert('Invalid captcha.');
    return;
  }

  if (!typedCaptcha) {
    posting.applyBans(typedCaptcha);
  } else {
    var parsedCookies = api.getCookies();

    api.formApiRequest('solveCaptcha', {
      captchaId : parsedCookies.captchaid,
      answer : typedCaptcha
    }, function solvedCaptcha(status, data) {

      if (status !== 'ok') {
        alert(status);
        return;
      }

      posting.applyBans(parsedCookies.captchaid);
    });
  }

};

posting.deleteFromIpOnThread = function() {
  posting.deleteFromIpOnBoard(null, true);
};

posting.deleteFromIpOnBoard = function(event, onThread) {

  var checkBoxes = document.getElementsByClassName('deletionCheckBox');

  for (var i = 0; i < checkBoxes.length; i++) {
    var checkBox = checkBoxes[i];

    if (checkBox.checked) {
      var splitName = checkBox.name.split('-')[0];
      break;
    }

  }

  if (!splitName) {
    return;
  }

  var redirect = '/' + splitName + '/';

  var confirmationBox = document
      .getElementById('ipDeletionConfirmationCheckbox');

  var param = {
    action : onThread ? 'thread-ip-deletion' : 'ip-deletion',
    confirmation : confirmationBox.checked
  };

  posting.newGetSelectedContent(param);

  api.formApiRequest('contentActions', param, function requestComplete(status,
      data) {

    if (status === 'ok') {
      window.location.pathname = redirect;
    } else {
      alert(status + ': ' + JSON.stringify(data));
    }
  });

};

posting.processIdLabel = function(label) {

  var id = label.innerHTML;

  var array = posting.idsRelation[id] || [];
  posting.idsRelation[id] = array;

  // Resolve the post cell by walking up to .innerPost/.innerOP instead of a fixed
  // parentNode depth: the title line gained .postMeta wrappers (2026-08-17), so the
  // old 3-level chain now lands on .postMeta — clicking then renamed the WRAPPER to
  // 'markedPost' (dashed outline + stray ">>" glyph) instead of highlighting the post.
  var cell = label;
  while (cell && !/(^|\s)(innerPost|innerOP)(\s|$)/.test(cell.className)) {
    cell = cell.parentNode;
  }

  if (cell) array.push(cell);

  // Mobile (<=479px) the sphere is a dot and the count lives in the sibling
  // .idCount, which postBurger.js alters on hover — so skip this text rewrite
  // here: it would (a) be invisible anyway and (b) poison fillIdCounts()'s
  // label.textContent read when its MutationObserver recounts, clearing the
  // count entirely (2026-08-17 operator report: "x2 then disappears").
  var idHoverNarrow = window.matchMedia ? window.matchMedia('(max-width: 479px)') : null;

  label.onmouseover = function() {
    if (idHoverNarrow && idHoverNarrow.matches) return;
    label.innerHTML = id + ' (' + array.length + ')';
  }

  label.onmouseout = function() {
    if (idHoverNarrow && idHoverNarrow.matches) return;
    label.innerHTML = id;
  }

  label.onclick = function() {

    // One ID highlighted at a time (2026-08-17, operator call): re-clicking the
    // highlighted ID toggles it off; clicking a DIFFERENT ID clears every other
    // highlight first (the old behavior let highlights accumulate until reload).
    var turningOff = posting.highLightedIds.length === 1 && posting.highLightedIds[0] === id;

    posting.highLightedIds.length = 0;
    if (!turningOff) posting.highLightedIds.push(id);

    // Apply the resulting state to every tracked cell of every ID on the page.
    for (var knownId in posting.idsRelation) {
      var cells = posting.idsRelation[knownId];
      var on = posting.highLightedIds.indexOf(knownId) > -1;
      for (var i = 0; i < cells.length; i++) {
        if (cells[i].className === 'innerOP') continue;   // OP never highlights (pre-existing)
        cells[i].className = on ? 'markedPost' : 'innerPost';
      }
    }

  };

};


posting.updateAllLocalTimes = function() {

  var times = document.querySelectorAll("span.labelCreated");

  for (var i = 0; i < times.length; i++) {
    posting.addLocalTime(times[i]);
  }

};

posting.addLocalTime = function(time) {

  var text = time.textContent.replace(/-/g,"/");
  var date_full = new Date(text+" +0000")

  var month = ('0' + (date_full.getMonth() + 1)).slice(-2);
  var day = ('0' + date_full.getDate()).slice(-2);
  var year = date_full.getFullYear();
  var new_date = year + '-' + month + '-' + day;

  var time_new = date_full.toLocaleTimeString("de-DE")

  time.textContent = new_date + " " + time_new;

};

posting.updateAllRelativeTimes = function() {

  var times = document.getElementsByClassName('labelCreated');

  for (var i = 0; i < times.length; i++) {
    posting.addRelativeTime(times[i]);
  }

};

/* Parse the date text a .labelCreated currently holds into an epoch ms.
   Handles the three formats this cell can hold:
     A: MM/DD/YYYY HH:MM:SS        raw server string (UTC) — convertLocalTimes off
     B: YYYY-MM-DD HH:MM:SS        after posting.addLocalTime (the default view)
     C: MM/DD/YYYY (Mon) HH:MM:SS  live posts pre-local-conversion (api.formatDateToDisplay)
   Returns null for anything unrecognised -> caller leaves the element alone. */
posting.parseCreated = function(text) {

  var t = (text || '').replace(/\([A-Z][a-z]{2}\)/, ' ').replace(/\s+/g, ' ').trim();
  var m;

  if ((m = t.match(/^(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2}):(\d{2})$/))) {
    return Date.UTC(+m[3], +m[1] - 1, +m[2], +m[4], +m[5], +m[6]);
  }

  if ((m = t.match(/^(\d{4})-(\d{2})-(\d{2}) (\d{2}):(\d{2}):(\d{2})$/))) {
    return new Date(+m[1], +m[2] - 1, +m[3], +m[4], +m[5], +m[6]).getTime();
  }

  return null;

};

/* Desktop relative-time label. The v6 status-line refactor made .labelCreated the
   LAST child of .postMetaBody, so the old nextSibling/nextSibling.nextSibling walk
   hit null and threw on every call (feature dead + it aborted the live-post path).
   Now: append a single .relativeTime span right after the date (a sibling, never
   inside the element — so mobile's postDate.js rewrites of labelCreated textContent
   don't clobber it), idempotent, and re-run every minute by updateAllRelativeTimes.
   Reuses the same lang keys (yAgo/monAgo/dAgo/hAgo/mAgo/justNow) as before. */
posting.addRelativeTime = function(time) {

  var epoch = posting.parseCreated(time.textContent);

  if (epoch === null) return;                 // unknown format — never blank it

  var label = time.nextElementSibling;

  if (!label || !label.classList.contains('relativeTime')) {
    label = document.createElement('span');
    label.className = 'relativeTime';
    time.parentNode.insertBefore(label, time.nextSibling);
  }

  var now = new Date();
  var content;
  var delta = now - epoch;

  var second = 1000;
  var minute = second * 60;
  var hour = minute * 60;
  var day = hour * 24;
  var month = day * 30.5;
  var year = day * 365.25;

  if (delta > year) {
    content = lang.yAgo.replace('__value__', Math.round(delta / year));
  } else if (delta > month) {
    content = lang.monAgo.replace('__value__', Math.round(delta / month));
  } else if (delta > day) {
    content = lang.dAgo.replace('__value__', Math.round(delta / day));
  } else if (delta > hour) {
    content = lang.hAgo.replace('__value__', Math.round(delta / hour));
  } else if (delta > minute) {
    content = lang.mAgo.replace('__value__', Math.round(delta / minute));
  } else {
    content = lang.justNow;
  }

  label.textContent = ' - ' + content;

};

posting.spoilFiles = function() {

  var posts = {
    action : 'spoil'
  };

  posting.newGetSelectedContent(posts);

  api.formApiRequest('contentActions', posts, function requestComplete(status,
      data) {

    if (status === 'ok') {

      alert('Files spoiled');

    } else {
      alert(status + ': ' + JSON.stringify(data));
    }
  });

};

posting.newGetSelectedContent = function(object) {

  var checkBoxes = document.getElementsByClassName('deletionCheckBox');

  for (var i = 0; i < checkBoxes.length; i++) {
    var checkBox = checkBoxes[i];

    if (checkBox.checked) {
      object[checkBox.name] = true;
    }
  }

};

posting.hideSelectedContentAndUncheck = function() {

  var checkBoxes = document.getElementsByClassName('deletionCheckBox');

  for (var i = 0; i < checkBoxes.length; i++) {
    var checkBox = checkBoxes[i];

    if (checkBox.checked) {
      var linkSelf = checkBox.parentNode.getElementsByClassName('linkSelf')[0];
      var groups = checkBox.name.match(/\w+/g);
      var board = groups[0];
      var thread = groups[1];
      if (groups.length == 2) {
        hiding.hideThread(linkSelf, board, thread);
      } else {
        var post = groups[2];
        hiding.hidePost(linkSelf, board, thread, post || thread, true);
      }
      checkBox.checked = false;
    }
  }

};

posting.reportPosts = function() {

  var fieldCaptchaReport = document.getElementById('fieldCaptchaReport');
  var typedReason = document.getElementById('reportFieldReason').value.trim();

  if (!api.noReportCaptcha) {
    var typedCaptcha = document.getElementById('fieldCaptchaReport').value.trim();
    if (/\W/.test(typedCaptcha)) {
      alert('Invalid captcha.');
      return;
    }
  }

  var reportCategories = document.getElementById('reportComboboxCategory');

  if (reportCategories) {
    var category = reportCategories.options[reportCategories.selectedIndex].value;
  }

  var params = {
    action : 'report',
    categoryReport : category,
    reasonReport : typedReason,
    captchaReport : typedCaptcha,
    globalReport: document.getElementById('checkboxGlobalReport').checked,
  };

  posting.newGetSelectedContent(params);

  api.formApiRequest('contentActions', params, function reported(status, data) {

    if (status === 'ok') {

      alert('Content reported');

      posting.hideSelectedContentAndUncheck();

      captchaUtils.reloadCaptcha();

    } else {
      alert(status + ': ' + JSON.stringify(data));
    }

  });

};

posting.trashPosts = function() {
  posting.deletePosts(null, true);
};

posting.deletePosts = function(event, trash) {

  var typedPassword = document.getElementById('deletionFieldPassword').value
      .trim();

  if (typedPassword.length > 8) {
      typedPassword = typedPassword.substring(0, 8);
  }

  var params = {
    password : typedPassword,
    deleteMedia : document.getElementById('checkboxMediaDeletion').checked,
    deleteUploads : document.getElementById('checkboxOnlyFiles').checked,
    action : trash ? 'trash' : 'delete'
  };

  posting.newGetSelectedContent(params);

  api.formApiRequest('contentActions', params, function requestComplete(status,
      data) {

    if (status === 'ok') {

      alert(data.removedThreads + ' threads and ' + data.removedPosts
          + ' posts were successfully deleted.');

      if (typeof latestPostings !== 'undefined') {

        posting.removeSelectedCells();

      } else if (window.location.toString().indexOf('trashBin.js' >= 0)) {
        location.reload(true);
      } else if (!api.isBoard && !data.removedThreads && data.removedPosts) {
        // Staff on a thread page: remove the deleted cells in place (no reload,
        // no scroll reset). thread.refreshPosts() refetches the (stale) thread
        // JSON and reflows the whole page, which is the "my view jumped / I
        // can't tell what I already killed" class. Anons keep refreshPosts
        // (their deletes are hard deletes and self-heal on reload).
        if (document.body.classList.contains('staffView')) {
          posting.removeSelectedCells();
        } else {
          thread.refreshPosts(true, true);
        }
      } else if (data.removedThreads || data.removedPosts) {
        window.location.pathname = '/';
      }

    } else {
      alert(status + ': ' + JSON.stringify(data));
    }
  });

};

posting.removeSelectedCells = function() {

  var checkBoxes = document.getElementsByClassName('deletionCheckBox');

  for (var i = checkBoxes.length - 1; i >= 0; i--) {
    var checkBox = checkBoxes[i];

    if (checkBox.checked) {
      checkBox.closest('.postCell, .opCell').remove();   /* two-row status line; OP lives in .opCell */
    }

  }

};

posting.formatFileSize = function(size) {

  var orderIndex = 0;

  while (orderIndex < posting.sizeOrders.length - 1 && size > 1024) {

    orderIndex++;
    size /= 1024;

  }

  return size.toFixed(2) + ' ' + posting.sizeOrders[orderIndex];

};

posting.setLastEditedLabel = function(post, cell) {

  var editedLabel = cell.getElementsByClassName('labelLastEdit')[0];

  if (post.lastEditTime) {

    var formatedDate = api.formatDateToDisplay(new Date(post.lastEditTime));

    var login = post.lastEditLogin;

    if (login) {
      editedLabel.innerHTML = lang.guiEditInfoMod.replace('__login__', login);
    } else {
      editedLabel.innerHTML = lang.guiEditInfo;
    }

    editedLabel.innerHTML = editedLabel.innerHTML.replace('__date__', formatedDate);

  } else {
    editedLabel.remove();
  }

};

posting.truncateFilename = function(filename, maxWidth, dots) {
  if (filename.length > maxWidth) {
    var truncateAtEnd = true;
    var parts = filename.split('.');
    var numParts = parts.length;
    var extension = parts.pop();
    if (numParts >= 2) {
      filename = filename.substring(
        0,
        maxWidth - dots.length - extension.length - 1
      ) + dots + '.' + extension;
      truncateAtEnd = filename.length > maxWidth;
    }
    if (truncateAtEnd) {
      filename = filename.substring(
        0,
        maxWidth - dots.length
      ) + dots;
    }
  }
  return filename;
};

var DEAD_MEDIA_THUMB = '/.static/images/deadmedia.png';
var DEAD_MEDIA_FULL = '/.static/images/deadmedia-full.png';

posting.setUploadLinks = function(cell, file, noExtras) {

  var isDeadMedia = (file.thumb === DEAD_MEDIA_THUMB) || (file.path === DEAD_MEDIA_FULL);

  var thumbLink = cell.getElementsByClassName('imgLink')[0];
  thumbLink.href = file.path;

  thumbLink.setAttribute('data-filemime', file.mime);

  if (!isDeadMedia
      && file.mime.indexOf('image/') > -1 && !noExtras
      && (typeof gallery !== 'undefined') && !api.mobile) {
    gallery.addGalleryFile(file.path);
  }

  var img = document.createElement('img');
  img.src = file.thumb;
  // static-thumb pair (2026-10-18): WS-inserted thread cells are built
  // client-side AFTER the page-level applyAnimationSetting pass (same gap the
  // catalog cells closed) — apply the rule at build time. Recording origSrc
  // keeps the autoplay-OFF restore working when the setting toggles later.
  if (file.animatedThumb) {
    img.dataset.animatedThumb = file.animatedThumb;
    if (settings.get('autoPlayAnimations')) {
      img.dataset.origSrc = file.thumb;
      img.src = file.animatedThumb;
    }
  }
  var dimensions = thumbs.getDimensions(file.width, file.height, file.thumb);
  img.width = dimensions[0];
  img.height = dimensions[1];
  img.title = isDeadMedia ? 'media no longer available' : file.originalName;

  if (settings.get('previewOnHover') && !isDeadMedia) {
    thumbLink.onmouseenter = preview.show;
    thumbLink.onmouseleave = preview.remove;
  }

  thumbLink.appendChild(img);

  var nameLink = cell.getElementsByClassName('nameLink')[0];
  nameLink.href = file.path;

  var filename = "";
  var extension = "";
  var splittedName = file.originalName.split(".")
  if (splittedName.length == 1) {
    filename = file.originalName;
  } else {
    extension = splittedName[splittedName.length-1];
    filename = file.originalName.slice(0, file.originalName.length - extension.length - 1);
  }

  var originalLink = cell.getElementsByClassName('originalNameLink')[0];
  originalLink.innerHTML = filename;
  if (isDeadMedia) {
    originalLink.href = file.path;
    originalLink.removeAttribute('download');
    originalLink.title = 'media no longer available';
  } else {
    originalLink.href = file.path + "/dl/" + encodeURIComponent(file.originalName);
    if (!posting.rewriteUrlsEnabled) {
      originalLink.href = file.path;
    }
    originalLink.title = file.originalName;
    originalLink.setAttribute('download', file.originalName);
  }

  var originalLink2 = cell.getElementsByClassName('originalNameLink2')[0];
  originalLink2.innerHTML = "." + extension;
  if (isDeadMedia) {
    originalLink2.href = file.path;
    originalLink2.removeAttribute('download');
  } else {
    originalLink2.href = file.path + "/dl/" + encodeURIComponent(file.originalName);
    if (!posting.rewriteUrlsEnabled) {
      originalLink2.href = file.path;
    }
    originalLink2.title = file.originalName;
    originalLink2.setAttribute('download', file.originalName);
  }

  // Fit the cell to the thumb width (live posts; loaded pages are covered by thumbs.init).
  if (typeof thumbs !== 'undefined' && thumbs.fitCellToThumb) {
    thumbs.fitCellToThumb(thumbLink);
  }
};

posting.getUploadCellBase = function() {

  var cell = document.createElement('figure');
  cell.innerHTML = posting.uploadCell;
  cell.className = 'uploadCell';

  return cell;

}

posting.setUploadCell = function(node, files, noExtras, boardUri, post) {

  if (!files) {
    return;
  }

  for (var i = 0; i < files.length; i++) {
    var file = files[i];

    var cell = posting.getUploadCellBase();

    posting.setUploadLinks(cell, file, noExtras);

    var sizeString = posting.formatFileSize(file.size);
    cell.getElementsByClassName('sizeLabel')[0].innerHTML = sizeString;

    var dimensionLabel = cell.getElementsByClassName('dimensionLabel')[0];

    if (file.width) {
      dimensionLabel.innerHTML = file.width + 'x' + file.height;
    } else {
      dimensionLabel.remove();
    }

    if (file.sha256) {
      cell.getElementsByClassName('unlinkLink brackets')[0].href = 'unlinkSingle.js?boardUri=' + boardUri + '&postId=' + post.postId + '&index=' + i;
      cell.getElementsByClassName('unlinkAndDeleteLink brackets')[0].href = 'unlinkSingle.js?boardUri=' + boardUri + '&postId=' + post.postId + '&index=' + i + '&delete=1';
    } else {
      cell.getElementsByClassName('unlinkLink brackets')[0].remove();
      cell.getElementsByClassName('unlinkAndDeleteLink brackets')[0].remove();
    }

    node.appendChild(cell);
  }

};

posting.setPostHideableElements = function(postCell, post, noExtras, boardUri) {

  var subjectLabel = postCell.getElementsByClassName('labelSubject')[0];

  if (post.subject) {
    subjectLabel.innerHTML = post.subject;
  } else {
    subjectLabel.remove();
  }

  if (post.id) {
    var labelId = postCell.getElementsByClassName('labelId')[0];
    labelId.setAttribute('style', 'background-color: #' + post.id);
    labelId.innerHTML = post.id;

    if (!noExtras) {
      posting.processIdLabel(labelId);
    }

  } else {
    var spanId = postCell.getElementsByClassName('spanId')[0];
    spanId.remove();
  }

  var banMessageLabel = postCell.getElementsByClassName('divBanMessage')[0];

  if (!post.banMessage) {
    banMessageLabel.parentNode.removeChild(banMessageLabel);
  } else {
    banMessageLabel.innerHTML = post.banMessage;
  }

  posting.setLastEditedLabel(post, postCell);

  var imgFlag = postCell.getElementsByClassName('imgFlag')[0];

  if (post.flag) {

    if (post.signedRole) {
      post.flag = '/.static/flags/kohl.png';
      post.flagName = '010011010110111101100100';
    }

    imgFlag.src = post.flag;
    imgFlag.title = post.flagName.replace(/&(l|g)t;/g, function replace(match) {
      return posting.reverseHTMLReplaceTable[match];
    });

    if (post.flagCode) {
      var flagCode = post.flagCode.replace('-', '');
      imgFlag.className += ' flag-' + flagCode;
      imgFlag.alt = flagCode;
      if (typeof medals !== 'undefined') {
        medals.addTooltip(imgFlag);
      }
    }
  } else {
    imgFlag.remove();
  }

  if (!post.asn) {
    postCell.getElementsByClassName('panelASN')[0].remove();
  } else {
    postCell.getElementsByClassName('labelASN')[0].innerHTML = post.asn;
  }

  if (!post.bypassId) {
    postCell.getElementsByClassName('panelBypassId')[0].remove();
  } else {
    postCell.getElementsByClassName('labelBypassId')[0].innerHTML = post.bypassId;
  }

  if (!post.broadRange) {
    postCell.getElementsByClassName('panelRange')[0].remove();
  } else {
    postCell.getElementsByClassName('labelBroadRange')[0].innerHTML = post.broadRange;
    postCell.getElementsByClassName('labelNarrowRange')[0].innerHTML = post.narrowRange;
  }

  /*
  if (!post.realBroadRange) {
    postCell.getElementsByClassName('panelRealRange')[0].remove();
  } else {
    postCell.getElementsByClassName('labelRealBroadRange')[0].innerHTML = post.realBroadRange;
    postCell.getElementsByClassName('labelRealNarrowRange')[0].innerHTML = post.realNarrowRange;
  }
  */

  if (post.realIpIsTor) {
    postCell.getElementsByClassName('labelRealIp')[0].innerText = 'Tor';
  } else if (post.realIp) {
    postCell.getElementsByClassName('labelRealIp')[0].innerText = post.realIp;
  } else {
    postCell.getElementsByClassName('panelRealIp')[0].remove();
  }

  if (!post.ip) {
    postCell.getElementsByClassName('panelIp')[0].remove();
  } else {
    postCell.getElementsByClassName('labelIp')[0].innerHTML = post.ip;
  }

  if (!post.ip && !post.bypassId) {
    postCell.getElementsByClassName('modLinks')[0].remove();
  }

};

posting.setPostLinks = function(postCell, post, boardUri, link, threadId,
    linkQuote, deletionCheckbox, preview) {

  var postingId = post.postId || threadId;

  var linkStart = (preview ? '/' + boardUri + '/res/' + threadId + '.html' : '')
      + '#';

  linkQuote.href = linkStart;
  link.href = linkStart;

  link.href += postingId;
  linkQuote.href += 'q' + postingId;

  var linkEdit = postCell.getElementsByClassName('linkEdit')[0];
  var linkHistory = postCell.getElementsByClassName('linkHistory')[0];
  var linkFileHistory = postCell.getElementsByClassName('linkFileHistory')[0];
  var linkOffenseHistory = postCell.getElementsByClassName('linkOffenseRecord')[0];

  var complement = (post.postId ? 'postId' : 'threadId') + '=' + postingId;

  if (api.mod) {
    linkEdit.href = '/edit.js?boardUri=' + boardUri + '&';
    linkEdit.href += complement;
  } else if (linkEdit) {
    linkEdit.remove();
  }

  if (api.mod && (post.ip || post.bypassId)) {
    linkFileHistory.href = '/mediaManagement.js?boardUri=' + boardUri + '&';
    linkFileHistory.href += complement;

    linkHistory.href = '/latestPostings.js?boardUri=' + boardUri + '&';
    linkHistory.href += complement;

    linkOffenseHistory.href = '/offenseRecord.js?boardUri=' + boardUri + '&';
    linkOffenseHistory.href += complement;

  } else if (linkHistory) {
    linkHistory.remove();
    linkFileHistory.remove();
    linkOffenseHistory.remove();
  }

  var checkboxName = boardUri + '-' + threadId;

  if (post.postId) {
    checkboxName += '-' + post.postId;
  }

  deletionCheckbox.setAttribute('name', checkboxName);

};

posting.setRoleSignature = function(postingCell, posting) {

  var labelRole = postingCell.getElementsByClassName('labelRole')[0];

  if (posting.signedRole) {
    labelRole.innerHTML = posting.signedRole;
  } else {
    labelRole.parentNode.removeChild(labelRole);
  }

};

posting.setPostComplexElements = function(postCell, post, boardUri, threadId,
    noExtras, preview) {

  posting.setRoleSignature(postCell, post);

  var link = postCell.getElementsByClassName('linkSelf')[0];

  var linkQuote = postCell.getElementsByClassName('linkQuote')[0];
  linkQuote.innerHTML = post.postId || threadId;

  var deletionCheckbox = postCell.getElementsByClassName('deletionCheckBox')[0];

  posting.setPostLinks(postCell, post, boardUri, link, threadId, linkQuote,
      deletionCheckbox, preview);

  var panelUploads = postCell.getElementsByClassName('panelUploads')[0];

  if (!post.files || !post.files.length) {
    panelUploads.remove();
  } else {

    if (post.files.length > 1) {
      panelUploads.className += ' multipleUploads';
    }

    posting.setUploadCell(panelUploads, post.files, noExtras, boardUri, post);
  }

};

posting.setPostInnerElements = function(boardUri, threadId, post, postCell,
    noExtras, preview) {

  var linkName = postCell.getElementsByClassName('linkName')[0];
  var sage = postCell.getElementsByClassName('sage')[0];

  linkName.innerHTML = post.name;

  if (post.email == 'sage') {
    sage.innerHTML = 'SÄGE!';
  }

  linkName.className += ' noEmailName';

  var labelCreated = postCell.getElementsByClassName('labelCreated')[0];

  labelCreated.innerHTML = api.formatDateToDisplay(new Date(post.creation));

  if (posting.localTimes) {
    posting.setLocalTime(labelCreated);
  }

  postCell.getElementsByClassName('divMessage')[0].innerHTML = post.markdown;

  posting.setPostHideableElements(postCell, post, noExtras, boardUri);

  posting.setPostComplexElements(postCell, post, boardUri, threadId, noExtras,
      preview);

  posting.addLocalTime(labelCreated);

  if (settings.get('relativeTime')) {
    posting.addRelativeTime(labelCreated);
  }

  var messageLinks = postCell.getElementsByClassName('divMessage')[0]
      .getElementsByTagName('a');

  /*
  for (var i = 0; i < messageLinks.length; i++) {
    embed.processLinkForEmbed(messageLinks[i]);
  }
  */

  var links = postCell.getElementsByClassName('imgLink');

  var temporaryImageLinks = [];

  for (i = 0; i < links.length; i++) {
    temporaryImageLinks.push(links[i]);
  }

  for (i = 0; i < temporaryImageLinks.length; i++) {
    thumbs.processImageLink(temporaryImageLinks[i]);
  }

  var shownFiles = postCell.getElementsByClassName('uploadCell');

  if (settings.get('mediaHiding')) {

    for (var i = 0; i < shownFiles.length; i++) {
      mediaHiding.processFileForHiding(shownFiles[i]);
    }

    var hiddenMedia = mediaHiding.getHiddenMedia();

    for (i = 0; i < hiddenMedia.length; i++) {
      mediaHiding.updateHiddenFiles(hiddenMedia[i], true);
    }

  }

  /* Staff "Delete File" for the collapsed mobile grid (mobileFileDelete.js).
     A live-added post's cell is built client-side, so the control has to be
     minted here too -- same hook mediaHiding uses above. Guarded because
     posting.js is loaded on pages that may not carry the module. */
  if (typeof mobileFileDelete !== 'undefined') {
    for (var mfdIndex = 0; mfdIndex < shownFiles.length; mfdIndex++) {
      mobileFileDelete.processCell(shownFiles[mfdIndex]);
    }
  }

  postCell.setAttribute('data-boarduri', boardUri);

  if (settings.get('showYous')) {
    tooltips.markYouPost(postCell, tooltips.getUserPosts());
  }

  if (noExtras) {
    return;
  }

  tooltips.addToKnownPostsForBackLinks(postCell);

  var quotes = postCell.querySelectorAll('.quoteLink,.highlightlink');

  for (i = 0; i < quotes.length; i++) {
    tooltips.processQuote(quotes[i]);
  }

  var linkSelf = postCell.getElementsByClassName('linkSelf')[0];
  hiding.setHideMenu(linkSelf);
  postingMenu.setExtraMenu(linkSelf)

  if (api.threadId) {
    thread.processPostingQuote(postCell.getElementsByClassName('linkQuote')[0]);
  }

  var expandId = boardUri + '-' + threadId + '-' + post.postId;

  postCell.getElementsByClassName('expandCheckBox')[0].setAttribute('id', expandId);
  postCell.getElementsByClassName('expandLabel')[0].setAttribute('for', expandId);
  postCell.getElementsByClassName('collapseLabel')[0].setAttribute('for', expandId);

};

posting.addPost = function(post, boardUri, threadId, noExtra, preview) {

  var postCell = document.createElement('div');
  postCell.innerHTML = posting.postCellTemplate;

  postCell.id = post.postId;
  postCell.setAttribute('class', 'postCell');

  postCell.setAttribute('data-boarduri', boardUri);

  if (preview) {
    var labelBoard = '/' + boardUri + '/';
    postCell.getElementsByClassName('labelBoard')[0].innerHTML = labelBoard;
  }

  posting.setPostInnerElements(boardUri, threadId, post, postCell, noExtra,
      preview);

  posting.fixModLinks(postCell);

  posting.addAsnLinks(postCell);

  if (!settings.get('autoPlayAnimations')) {
    uploadCells = postCell.querySelectorAll(".uploadCell");
    for(var i = 0; i < uploadCells.length; i++) {
      posting.freezeAnimatedThumb(uploadCells[i]);
    }
  }

  if (settings.get('editInOekaki')) {
    uploadCells = postCell.querySelectorAll(".uploadCell");
    for(var i = 0; i < uploadCells.length; i++) {
      posting.addEditLinks(uploadCells[i]);
    }
  }

  if (settings.get('audioThread')) {
    originalNameLinks = postCell.querySelectorAll(".originalNameLink");
    for(var i = 0; i < originalNameLinks.length; i++) {
      audioThread.addAudioPlayer(originalNameLinks[i]);
    }
  }

  // tipping.js
  if (typeof tipping !== 'undefined') {
    messageSubjects = postCell.querySelectorAll("span.labelSubject");
    for(var i = 0; i < messageSubjects.length; i++) {
      tipping.processSubject(messageSubjects[i]);
    }
  }


  return postCell;

};

posting.fixModLinks = function(postCell) {

  var currentThread;
  var currentBoard;

  if (window.location.pathname != "/mod.js" && !/^\/\w+\/last\//.test(window.location.pathname)) {
    return;
  }

  if (window.location.pathname == "/mod.js") {
    var boardmatch = window.location.search.match(/\?boardUri=(\w+)/);
    var returnLinks = document.getElementsByClassName("returnLinks");
    for (i = 0; i < returnLinks.length; i++) {
      returnLinks[i].href = "/mod.js?boardUri=" + boardmatch[1];
    }
    var catalogLinks = document.getElementsByClassName("catalogLinks");
    for (i = 0; i < catalogLinks.length; i++) {
      catalogLinks[i].href = "/" + boardmatch[1] + "/catalog.html";
    }
    // 2026-10-22: secondaryBar Index/RSS are relative too (board.njk './',
    // thread.njk '../') — from /mod.js they resolved to '/' (= site homepage,
    // the operator-reported 'kicked to home' bug) and '/index.rss' (404).
    var indexLink = document.getElementById('linkIndex');
    if (indexLink) {
      indexLink.href = "/" + boardmatch[1] + "/";
    }
    var rssLink = document.getElementById('linkRss');
    if (rssLink) {
      rssLink.href = "/" + boardmatch[1] + "/index.rss";
    }
  }

  var regexMultiMatchBoardPage = /\/(\w+)\/res\/(\d+)\.html#(\d+)$/;

  var quoteLinks = postCell.querySelectorAll(".quoteLink");

  for (i = 0; i < quoteLinks.length; i++) {
    if (regexMultiMatchBoardPage.test(quoteLinks[i].href)) {
      var match = regexMultiMatchBoardPage.exec(quoteLinks[i].href);


      if (window.location.pathname == "/mod.js") {

        quoteLinks[i].href = "/mod.js?boardUri=" + match[1] + "&threadId=" + match[2] + "#" + match[3];

      } else if (/^\/\w+\/last\//.test(window.location.pathname)) {

        if (document.getElementById(match[3]) == null) {
          quoteLinks[i].href = "/" + match[1] + "/res/" + match[2] + ".html#" + match[3];
        } else {
          quoteLinks[i].href = "#" + match[3];
        }
      }
    }
  }
}


posting.updateAllModLinks = function() {
  var postCells = document.getElementsByClassName('postCell');
  for (var i = 0; i < postCells.length; i++) {
    posting.fixModLinks(postCells[i]);
  }
};

posting.addAsnLinks = function (postCell) {

  if (window.location.pathname != "/mod.js" && window.location.pathname != "/latestPostings.js" && window.location.pathname != "/openReports.js") {
    return;
  }

  var labelASNs = postCell.getElementsByClassName("labelASN");

  for (var i = 0; i < labelASNs.length; i++) {
    var labelASN = labelASNs[i];
    var aElement = document.createElement("a");
    aElement.setAttribute('href', "https://ipinfo.io/AS" + labelASN.innerText);
    aElement.setAttribute('target', "_blank");
    var linkText = document.createTextNode(labelASN.innerText);
    aElement.appendChild(linkText);
    labelASN.innerText = "";
    labelASN.appendChild(aElement);
  }
}

posting.updateAllAsnLinks = function() {
  var postCells = document.getElementsByClassName('innerPost');
  for (var i = 0; i < postCells.length; i++) {
    posting.addAsnLinks(postCells[i]);
  }
};

/* Animated-thumb control (rewired 2026-09): with ffmpegGifs, GIF thumbs are
   served as animated APNGs and <img> plays them natively, so autoPlayAnimations
   is now a KILL SWITCH instead of an enabler. OFF (default) freezes each
   animated thumb on its first frame by swapping src for a canvas-rendered data
   URL; ON leaves native playback alone. The <img> element itself survives the
   swap, so expand/collapse, sfw-mode and thumbfit CSS all keep working as-is.
   Animated-vs-static is decided by byte sniffing (GIF magic / PNG acTL /
   WebP ANIM): extensionless thumbs can't be told apart by name, and small
   APNG/WebP posts that use themselves as their own thumb are covered too.
   The fetch is a guaranteed HTTP-cache hit (media ships max-age=1y), so there
   is no extra network cost. */
/* Animated-thumb control. Static-thumb pair (2026-10-18, operator ruling):
   for NEW GIF posts the server renders the static first frame as the thumb
   (src) and ships the animation URL in data-animated-thumb. Autoplay ON
   swaps src to the animation — only users who opted in pay for its bytes.
   Autoplay OFF = ZERO work for new-format thumbs: the served bytes are
   already a still, so no sniff fetch, no canvas swap, and the <img> never
   downloads the animation. OLD posts (thumb IS the animation, no
   data-animated-thumb) keep the 2026-09 byte-sniffing freeze path when OFF
   and native playback when ON — a previous canvas freeze is undone via
   dataset.origSrc.
   The 2026-09 notes below still hold for old posts: byte sniffing decides
   animated-vs-static (extensionless thumbs, self-thumbed APNG/WebP), and
   display must never break — any sniff failure leaves native playback. */
posting.applyAnimationSetting = function(autoplay) {

  var imgs = document.querySelectorAll('img[data-animated-thumb]');

  for (var i = 0; i < imgs.length; i++) {
    var img = imgs[i];
    if (autoplay) {
      if (img.dataset.origSrc === undefined) {
        img.dataset.origSrc = img.getAttribute('src');
      }
      img.src = img.dataset.animatedThumb;
    } else if (img.dataset.origSrc !== undefined) {
      img.src = img.dataset.origSrc;
    }
  }

  if (!autoplay) {
    posting.freezeAnimatedThumbs();
  }

};

posting.isAnimatedBytes = function(u8) {
  var i, len = u8.length;
  if (len < 12) return false;
  // GIF87a / GIF89a — always animated
  if (u8[0] === 71 && u8[1] === 73 && u8[2] === 70) return true;
  // WebP: animated iff the header region carries an ANIM chunk
  if (u8[0] === 82 && u8[1] === 73 && u8[2] === 70 && u8[3] === 70
      && u8[8] === 87 && u8[9] === 69 && u8[10] === 66 && u8[11] === 80) {
    for (i = 12; i + 4 <= Math.min(len, 64); i++) {
      if (u8[i] === 65 && u8[i+1] === 78 && u8[i+2] === 73 && u8[i+3] === 77) return true; // ANIM
    }
    return false;
  }
  // PNG: animated iff it carries an acTL chunk (APNG); walk chunks to IEND
  var sig = [137, 80, 78, 71, 13, 10, 26, 10];
  for (i = 0; i < 8; i++) if (u8[i] !== sig[i]) return false;
  for (i = 8; i + 12 <= len; i += 12 + ((u8[i] << 24 | u8[i+1] << 16 | u8[i+2] << 8 | u8[i+3]) >>> 0)) {
    if (u8[i+4] === 97 && u8[i+5] === 99 && u8[i+6] === 84 && u8[i+7] === 76) return true; // acTL
    if (u8[i+4] === 73 && u8[i+5] === 67 && u8[i+6] === 67 && u8[i+7] === 80) break; // IEND, no acTL
  }
  return false;
};

posting.freezeAnimatedThumb = function(uploadCell) {
  var img = uploadCell.querySelector('img');
  if (!img || img.dataset.animChecked) return;
  var url = img.getAttribute('src'); // raw attribute — .src/.currentSrc are absolute and would fail the check below
  if (!url || url.indexOf('/.media/') !== 0) return; // generic/mime/audio thumbs are never animated
  if (img.dataset.animatedThumb) return; // new-format thumb is a KNOWN static; bytes are never fetched
  img.dataset.animChecked = '1';

  var freeze = function() {
    if (!img.naturalWidth) return;
    var canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    canvas.getContext('2d').drawImage(img, 0, 0);
    img.dataset.origSrc = url; // remember the animation URL so autoplay ON can restore it live
    img.src = canvas.toDataURL('image/png');
  };

  fetch(url).then(function(response) {
    return response.ok ? response.arrayBuffer() : null;
  }).then(function(buf) {
    if (!buf || !posting.isAnimatedBytes(new Uint8Array(buf))) return;
    if (img.complete && img.naturalWidth) {
      freeze();
    } else {
      // loading="lazy": far-down-page thumbs load on scroll — freeze then
      img.addEventListener('load', function() {
        if (img.naturalWidth) freeze();
      }, { once: true });
    }
  }).catch(function() { /* sniff failed — leave native playback; display must never break */ });
};

posting.freezeAnimatedThumbs = function() {
  var uploadCells = document.querySelectorAll(".uploadCell");
  for (var i = 0; i < uploadCells.length; i++) {
    posting.freezeAnimatedThumb(uploadCells[i]);
  }
}

posting.addEditLinks = function(uploadCell) {
  var item = uploadCell;
  const imgLink = item.getElementsByClassName("imgLink")[0];
  if (imgLink.dataset.filemime && imgLink.dataset.filemime.split('/').shift() === 'image') {
    const editLink = item.getElementsByClassName("editInOekaki")[0];
    if (editLink) {
      editLink.style.display = '';
      editLink.href = imgLink.href
      editLink.onclick = function(event) {
        event.preventDefault();
        showOekaki(event);
      }
    }
  }
}



posting.updateAllEditLinks = function() {
  uploadCells = document.querySelectorAll(".uploadCell");
  for(var i = 0; i < uploadCells.length; i++) {
    posting.addEditLinks(uploadCells[i]);
  }
}

posting.checkRewriteUrls = function() {
  if (typeof document.getElementsByClassName('originalNameLink')[0] !== "undefined" && document.getElementsByClassName('originalNameLink')[0].href.indexOf("/dl/") > -1 ) {
    posting.rewriteUrlsEnabled = true;
  }
}

/* Staff U/D single-file links: answer via AJAX and drop the cell in place.
   The plain link navigates to an intermediate "click here" page that booted
   mods out of the thread after every cleanup; with json=1 the engine just
   returns {status:'ok'} and we remove the cell locally, so a cleanup pass
   over several files never leaves the thread. Delegation covers both
   server-rendered cells and client-built ones. */
posting.initUnlinkLinks = function() {

  document.addEventListener('click', function(event) {

    var link = event.target.closest ?
        event.target.closest('a.unlinkLink, a.unlinkAndDeleteLink') : null;

    if (!link) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();

    var cell = link.closest('.uploadCell');
    var href = link.getAttribute('href') || '';

    if (href.indexOf('json=1') === -1) {
      href += '&json=1';
    }

    fetch(href, { credentials : 'same-origin' })
        .then(function(response) {
          return response.json();
        })
        .then(function(data) {
          if (data && data.status === 'ok') {
            if (cell && cell.parentNode) {
              cell.parentNode.removeChild(cell);
            }
          } else {
            alert((data && data.data) || 'unlink failed');
          }
        }).catch(function() {
          alert('unlink failed');
        });

  }, true);
};

posting.init();

posting.initUnlinkLinks();
